import { Link, createFileRoute } from "@tanstack/react-router";
import { Trans } from "@lingui/react/macro";

import InfoPageShell from "../components/InfoPageShell";
import LandingLayout from "../components/LandingLayout";
import { clearBuilderFlowState } from "../lib/builderFlowStorage";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      {
        title: "BodaWeb — Términos",
      },
    ],
  }),
});

function TermsPage() {
  return (
    <LandingLayout showFooter>
      <InfoPageShell
        eyebrow={<Trans>Términos</Trans>}
        intro={
          <Trans>
            Estos términos describen, de forma breve y directa, cómo esperamos
            que se use BodaWeb y qué alcance tiene el servicio en su estado
            actual.
          </Trans>
        }
        title={<Trans>Términos del servicio</Trans>}
      >
        <section className="border-t border-[var(--color-border)] pt-8 first:border-t-0 first:pt-0">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Uso de la plataforma</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                BodaWeb está pensado para crear, gestionar y compartir
                invitaciones digitales de boda. Esperamos que el contenido que
                subas y publiques sea tuyo o que tengas permiso para usarlo.
              </Trans>
            </p>
            <p>
              <Trans>
                No debes utilizar la plataforma para contenido engañoso, dañino
                o que interfiera con la experiencia de otras personas.
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Cuenta, contenido y límites</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                Tu cuenta te da acceso a un solo sitio activo. Eres responsable
                de revisar que la información compartida con tus invitados sea
                correcta y esté actualizada.
              </Trans>
            </p>
            <p>
              <Trans>
                Algunas funciones pueden tener límites de uso o depender del
                plan disponible en tu cuenta. Si necesitas empezar un nuevo
                sitio, vuelve al flujo principal desde{" "}
                <Link
                  className="app-link cursor-pointer"
                  onClick={clearBuilderFlowState}
                  search={{ step: undefined, template: undefined }}
                  to="/create"
                >
                  Empezar Gratis
                </Link>
                .
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Disponibilidad y soporte</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                La aplicación está en una etapa temprana y puede cambiar con
                rapidez. Eso significa que algunas funciones, textos o flujos
                pueden ajustarse mientras seguimos mejorando el producto.
              </Trans>
            </p>
            <p>
              <Trans>
                Si ves algo inesperado o necesitas ayuda, puedes escribirnos a{" "}
                <a
                  className="app-link cursor-pointer"
                  href="mailto:soporte@bodaweb.site"
                >
                  soporte@bodaweb.site
                </a>
                .
              </Trans>
            </p>
          </div>
        </section>
      </InfoPageShell>
    </LandingLayout>
  );
}
